module.exports = __webpack_public_path__ + "files/794beeab79ed27c75690261b838991c5.png";